module.exports = __webpack_public_path__ + "img/repack.6ea1ae54.svg";